module.exports = __webpack_public_path__ + "static/media/contractors.d892b5b9.svg";